import Grid from '@mui/material/Grid';

import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { IconTypographyContainer } from 'reservations/base/components/IconTypography';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import {
  EvenSplitIconTypography,
  PrivatePaymentIconTypography
} from 'reservations/checklessPayments/components/SplitBillIconTypography';
import { GuestList } from 'reservations/guests/components/GuestList';

export const ViewSplitBillModal = () => {
  const { open } = useModal();

  return (
    <BaseDrawer
      dataTestId="view-split-bill-modal"
      header="Split the bill"
      secondaryButton={{
        label: 'REMOVE CARD',
        onClick: () => open(ModalType.RemoveCard),
        variant: 'error'
      }}
    >
      <IconTypographyContainer>
        <EvenSplitIconTypography />
        <PrivatePaymentIconTypography />
      </IconTypographyContainer>
      <Grid
        item
        sx={{
          marginTop: '24px',
          marginBottom: '16px'
        }}
      >
        <GuestList
          allowRemoval={false}
          includeDividers={false}
          showHeader={false}
        />
      </Grid>
    </BaseDrawer>
  );
};
